<template>
    <div class="messages">
        <div class="more" v-if="!messages.finished">
            <van-loading v-if="messages.loading" :size="20" />
            <div class="link" @click="onPage">查看更多</div>
        </div>
        <div class="content" ref="ContentRef" @scroll="onScroll">
            <ChatMessageItem :items="item" v-for="(item, index) in messages.list" :key="index"
                :doctor-image="orders.doctorImage" :user-image="orders.userImage" />
            <van-empty description="暂无沟通记录" v-if="messages.finished && !messages.list.length" />
        </div>
    </div>
</template>

<script>
import ChatMessageItem from '@/components/chat/message/item.vue'
import api from '@/utils/request'
export default {
    components: {
        ChatMessageItem
    },
    data() {
        return {
            orders: {},
            messages: {
                loading: false,
                finished: false,
                list: []
            },
            pages: {
                page: 1,
                pageSize: 10,
                total: 0
            },
            scrolls: {
                top: 0
            }
        }
    },
    mounted() {
        this.init()
    },
    activated() {
        if (this.scrolls.top) {
            if (this.$refs.ContentRef) {
                this.$refs.ContentRef.scrollTop = this.scrolls.top
            }
        }
    },
    methods: {
        async init() {
            this.messages.loading = true
            try {
                await this.onOrderGet()
                await this.onDataGet()
            } catch (error) { }
        },
        onPage() {
            if (this.messages.loading) return false
            this.pages.page++
            this.onDataGet()
        },
        async onDataGet() {
            this.messages.loading = true
            try {
                const { data } = await api({
                    method: 'get',
                    url: '/user-service/doctormg/askdetail/list',
                    params: {
                        askNo: this.$route.query.askNo,
                        doctorNo: this.orders.doctorNo,
                        pageNum: this.pages.page,
                        pageSize: this.pages.pageSize
                    }
                })
                const scrollHeight = this.$refs.ContentRef && this.$refs.ContentRef.scrollHeight || 0
                const scrollTop = this.$refs.ContentRef && this.$refs.ContentRef.scrollTop || 0
                this.messages.list = data.list.concat(this.messages.list)
                if (this.messages.list.length >= data.total || !data.list.length) {
                    this.messages.finished = true
                }
                this.onScrollSet(scrollHeight, scrollTop)
            } catch (error) { }
            this.messages.loading = false
        },
        onScrollSet(scrollHeight, scrollTop) {
            this.$nextTick(() => {
                if (this.$refs.ContentRef) {
                    if (this.pages.page === 1) {
                        this.$refs.ContentRef.scrollTop = this.$refs.ContentRef.scrollHeight
                    } else {
                        this.$refs.ContentRef.scrollTop = this.$refs.ContentRef.scrollHeight - scrollHeight + scrollTop
                    }
                }
            })
        },
        onScroll(event) {
            this.scrolls.top = event.target.scrollTop
            if (this.messages.loading || this.messages.finished) return false
            if (event.target.scrollTop === 0) {
                this.onPage()
            }
        },
        async onOrderGet() {
            const { data } = await api({
                method: 'get',
                url: '/user-service/askinfo/member/askDetail',
                params: {
                    askNo: this.$route.query.askNo
                }
            })
            this.orders = data
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/base";

.messages {
    font-size: 16px;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .more {
        @include flex(center, center);
        padding: 10px;
        text-align: center;
        color: $color-primary;

        .van-loading {
            margin-right: 5px;
        }

        .link {
            cursor: pointer;
        }
    }

    .content {
        flex: 1;
        overflow-y: auto;
    }
}
</style>